import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const submitContact = (data) => api.post("/leads/contact", data).then((r) => r.data);
export const submitBrochureLead = (data) => api.post("/leads/brochure", data).then((r) => r.data);
export const submitRegistration = (data) => api.post("/leads/registration", data).then((r) => r.data);
export const submitStrategyCall = (data) => api.post("/leads/strategy-call", data).then((r) => r.data);
export const submitConsultation = (data) => api.post("/leads/consultation", data).then((r) => r.data);
export const saveRegistrationPrize = (registrationId, prize) =>
  api.post(`/leads/registration/${registrationId}/prize`, prize).then((r) => r.data);
export const spinRegistrationWheel = (registrationId) =>
  api.post(`/leads/registration/${registrationId}/spin`).then((r) => r.data);
export const getRegistration = (registrationId) =>
  api.get(`/leads/registration/${registrationId}`).then((r) => r.data);
export const getEventCounter = () => api.get("/event/counter").then((r) => r.data);
export const listBlogPosts = () => api.get("/blog/posts").then((r) => r.data);
export const getBlogPost = (slug) => api.get(`/blog/posts/${slug}`).then((r) => r.data);
export const cpLogin = (password) => api.post("/cp/login", { password }).then((r) => r.data);
export const cpSummary = (token) => api.get("/cp/summary", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpListContactLeads = (token) => api.get("/leads/contact", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpListRegistrations = (token) => api.get("/leads/registration", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpListStrategyCalls = (token) => api.get("/leads/strategy-call", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpListConsultations = (token) => api.get("/leads/consultation", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpListChatLeads = (token) => api.get("/leads/chat", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const submitPartialRegistration = (data) =>
  api.post("/leads/registration/partial", data).then((r) => r.data);
export const cpGetIntegrations = (token) =>
  api.get("/admin/integrations", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpUpdateIntegrations = (token, data) =>
  api.put("/admin/integrations", data, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpTestCRMWebhook = (token) =>
  api.post("/admin/integrations/test-crm", null, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpWipeAllLeads = (token, confirmString) =>
  api
    .post("/admin/wipe-leads", { confirm: confirmString }, { headers: { "X-CP-Token": token } })
    .then((r) => r.data);
export const cpAnalyticsSummary = (token, days = 30) =>
  api.get(`/admin/analytics/summary?days=${days}`, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpAnalyticsInsights = (token) =>
  api.get("/admin/analytics/insights", { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpRegenerateInsights = (token) =>
  api.post("/admin/analytics/insights", null, { headers: { "X-CP-Token": token }, timeout: 60000 }).then((r) => r.data);

// Consultants directory
export const searchConsultants = (q, limit = 8) =>
  api.get(`/consultants/search`, { params: { q, limit } }).then((r) => r.data);
export const cpListConsultants = (token) =>
  api.get(`/admin/consultants`, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpCreateConsultant = (token, data) =>
  api.post(`/admin/consultants`, data, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpUpdateConsultant = (token, id, data) =>
  api.put(`/admin/consultants/${id}`, data, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpDeleteConsultant = (token, id) =>
  api.delete(`/admin/consultants/${id}`, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpUploadConsultantsCsv = (token, csvText, replaceExisting) =>
  api.post(`/admin/consultants/upload-csv`, { csv_text: csvText, replace_existing: replaceExisting }, { headers: { "X-CP-Token": token } }).then((r) => r.data);
export const cpExportUrl = (kind) => `${API}/admin/export/${kind}.xlsx`;

/**
 * Streams a chatbot reply from the backend as an async iterable of text chunks.
 */
export async function* streamChat({ sessionId, message, page }) {
  const resp = await fetch(`${API}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
    body: JSON.stringify({ session_id: sessionId, message, page }),
  });
  if (!resp.ok || !resp.body) {
    yield "I'm having trouble reaching my thoughts right now. Please WhatsApp us at wa.me/918446448123.";
    return;
  }
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) !== -1) {
      const rawEvent = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      // Each event is one or more "data: ..." lines
      const dataLines = rawEvent
        .split("\n")
        .filter((l) => l.startsWith("data:"))
        .map((l) => l.slice(5).replace(/^ /, ""));
      const combined = dataLines.join("\n");
      if (combined.trim() === "[DONE]") return;
      if (combined.length > 0) yield combined + "\n";
    }
  }
}
